module.exports = __webpack_public_path__ + "static/img/footer_jt_pic.4c2bc1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer_jt_pic.png
// module id = iDvL
// module chunks = 29